export const PURCHASE_STATUS = {
  PENDING: 'pending',
  FULFILL: 'fulfill',
  COLLECTED: 'collected',
  CANCEL: 'cancel',
  UNPAID: 'unpaid',
  READY: 'ready',
  REFUND: 'refund',
  VERIFIED: 'verified',
};
